import React, { useEffect, useState } from 'react';
import { Bell, BellOff, CheckCheck } from 'lucide-react';
import { api } from '../services/api';
import { useNotifStore } from '../store/notifStore';
import styles from './NotificationsPage.module.css';

const PRIORITY_CLASS = { urgent: 'red', high: 'amber', normal: 'accent', low: 'muted' };

export default function NotificationsPage() {
  const [loading, setLoading] = useState(true);
  const { notifications, setNotifications, markRead } = useNotifStore();

  useEffect(() => {
    api.get('/notifications/').then(data => {
      setNotifications(data);
      setLoading(false);
    });
  }, []);

  const markAll = async () => {
    await api.post('/notifications/read-all', {});
    setNotifications(notifications.map(n => ({ ...n, read: true })));
  };

  const unread = notifications.filter(n => !n.read).length;

  return (
    <div className={styles.page}>
      <div className={styles.header}>
        <div className={styles.headerLeft}>
          <Bell size={16} className="text-accent" />
          <h1 className={styles.title}>Notifiche</h1>
          {unread > 0 && <span className={styles.badge}>{unread}</span>}
        </div>
        {unread > 0 && (
          <button className={styles.markAllBtn} onClick={markAll}>
            <CheckCheck size={13} /> Segna tutte lette
          </button>
        )}
      </div>

      {loading ? (
        <div className={styles.empty}>Caricamento…</div>
      ) : notifications.length === 0 ? (
        <div className={styles.empty}>
          <BellOff size={32} className="text-3" />
          <p>Nessuna notifica</p>
        </div>
      ) : (
        <div className={styles.list}>
          {notifications.map(n => (
            <div
              key={n.id}
              className={`${styles.card} ${!n.read ? styles.unread : ''} fade-in`}
              onClick={() => !n.read && markRead(n.id) && api.patch(`/notifications/${n.id}/read`, {})}
            >
              <div className={`${styles.stripe} ${styles['stripe_' + (PRIORITY_CLASS[n.priority] || 'accent')]}`} />
              <div className={styles.cardBody}>
                <div className={styles.cardHeader}>
                  <span className={styles.cardTitle}>{n.title}</span>
                  {!n.read && <span className={styles.unreadDot} />}
                </div>
                <p className={styles.cardText}>{n.body}</p>
                <span className={styles.cardTime}>
                  {new Date(n.created_at).toLocaleString('it-IT', {
                    day: '2-digit', month: '2-digit',
                    hour: '2-digit', minute: '2-digit',
                  })}
                </span>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
